import $ from "jquery";
import axios from "axios";

const url = '/rest/survey/list/map';

export const radioInputToggle = () => {
    $('#signupquestionform-survey3question').on('change', function() {
        $(this).parent().find('label').hide();
    });

    $("#survey-2-question-id").on("change", function () {
        let answer = $("#survey-2-question-id").val();

        $('#survey-3-group').show();

        axios.get(url, {
            params: {
                key: answer,
            }
        })
            .then((response) => {
                $('#signupquestionform-survey3question').text('');

                $.each(response.data.data, function(index, value) {
                    $('#signupquestionform-survey3question').append(
                        '<option value="' + value + '">' + value + '</option>'
                    );
                });
            });
    });
}
